import { render } from "./SectionWrapper.vue?vue&type=template&id=2b75cfa8&scoped=true"
import script from "./SectionWrapper.vue?vue&type=script&lang=js"
export * from "./SectionWrapper.vue?vue&type=script&lang=js"

import "./SectionWrapper.vue?vue&type=style&index=0&id=2b75cfa8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b75cfa8"]])

export default __exports__